import React, {useState} from "react"
import {Address} from "../../../resources/common"
import {Modal} from "../../../components/Modals/Modal"
import {Formik} from "formik"
import {GridContainer} from "../../../containers/GridContainer/GridContainer"
import Button from "../../../components/Button/Button"
import AddressComponent, {addressValidationSchema} from "../../../components/Address/Address"
import * as Yup from "yup"

interface ChangeMailingAddressModalProps {
	address?: Address
	closeModal: () => void
	onSuccess: (formData: Address) => void
}

export function ChangeMailingAddressModal({address, closeModal, onSuccess}: ChangeMailingAddressModalProps) {
	const supportedCountry = "US"
	const defaultAddress: Address = {
		street: "",
		street2: "",
		city: "",
		state: "",
		postalCode: "",
		country: supportedCountry,
	}
	const validationSchema = Yup.object().shape(addressValidationSchema)

	const [formData] = useState<Address>(address ?? defaultAddress)

	const handleSave = (values: Address) => {
		onSuccess(values)
		closeModal()
	}

	return (
		<Formik
			initialValues={formData}
			validationSchema={validationSchema}
			onSubmit={(values) => {
				onSuccess(values)
				closeModal()
			}}
		>
			{({values, handleChange, setFieldValue, isValid, handleBlur}) => (
				<Modal close={closeModal} classname={"closure-check-modal"} enableClickAway={false}>
					<div className="modal-content">
						<h3 className="title is-4">Change Mailing Address</h3>
						<p>
							The closure check will be sent to this address. Note that the customer address in the dashboard will
							remain the same.
						</p>
					</div>
					<GridContainer rows={3} columns={2} gap="8px">
						<AddressComponent
							closed={false}
							street={values.street}
							street2={values.street2}
							city={values.city}
							country={values.country}
							state={values.state || "US"}
							postalCode={values.postalCode}
							isUsOnlyAddress={true}
							handleChange={handleChange}
							handleBlur={handleBlur}
							setFieldValue={setFieldValue}
						/>
					</GridContainer>
					<div className="modal-actions mt-4 is-flex is-justify-content-end">
						<Button className="button is-white is-light" onClick={closeModal}>
							Back
						</Button>
						<Button
							type="submit"
							onClick={() => handleSave(values)}
							className="button is-black wider"
							disabled={!isValid}
						>
							Save
						</Button>
					</div>
				</Modal>
			)}
		</Formik>
	)
}
